import buildClient from '@/api/client'
import expressApplePayCheckoutQuery from '@/api/checkout-applepay-express'
import expressApplePayCheckoutRequestQuery from '@/api/checkout-applepay-express-request'
import resetCurrentOrderQuery from '@/api/reset-current-order'

class ApiService {
  constructor(options = {}) {
    const { http, paths } = options
    this.http = http
    this.paths = paths
  }

  fetchApplePayExpressCheckout() {
    return buildClient().query(expressApplePayCheckoutQuery())
  }

  fetchApplePayExpressCheckoutRequest() {
    return buildClient()
      .query(expressApplePayCheckoutRequestQuery())
      .then(({ checkout }) => checkout.applePay.expressCheckoutRequest)
  }

  authorizeMerchant(validationURL) {
    return this.http.post(this.paths.authorizeMerchantsUrl, {
      url: validationURL,
    })
  }

  authorizePayment(paymentData) {
    return this.http.post(this.paths.applePayAuthorizePaymentUrl, paymentData)
  }

  updateCheckoutAddress(attrs) {
    return this.http.patch(this.paths.updateCheckoutAdressUrl, attrs)
  }

  updateCheckoutDelivery(attrs) {
    return this.http.patch(this.paths.updateCheckoutDeliveryUrl, attrs)
  }

  updateCheckoutRegistration(attrs) {
    return this.http.put(this.paths.updateCheckoutRegistrationUrl, attrs)
  }

  resetCurrentOrder() {
    return buildClient().query(resetCurrentOrderQuery())
  }
}

export default ApiService
